export enum RiskProfile {
  HIGH = 'HIGH',
  MED = 'MED',
  LOW = 'LOW',
}
